import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Button } from "antd";
import { useState } from "react";
import type { Swiper as SwiperType } from "swiper";
import PaginationSwiper from "./PaginationSwiper";

export default function SliderBanner() {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const handleSlideChange = (swiper: SwiperType) => {
    setCurrentIndex(swiper?.realIndex);
  };

  return (
    <div className="w-full rounded-3xl overflow-hidden">
      <Swiper
        slidesPerView={1}
        onSlideChange={handleSlideChange}
        spaceBetween={20}
        className="w-full h-80 relative"
      >
        {Array.from({ length: 3 })?.map((e, i) => (
          <SwiperSlide
            key={"banner-item" + i}
            className="w-full! rounded-3xl h-full! relative overflow-hidden"
          >
            <img
              className="w-full object-cover h-full"
              src="/image/Banner(6).png"
              alt=""
            />
            <div className="h-full absolute gap-8 pr-20 justify-center w-[45%] top-0 right-0 flex flex-col">
              <div className="flex flex-col gap-4">
                <h2 className="display-32-bold">
                  مدیریت هوشمند، تصمیم‌گیری سریع
                </h2>
                <p className="text-20-regular text-grayscale-800">
                  با داشبورد یکپارچه مدیرینو، عملکرد سیستم را در یک نگاه کنترل
                  کنید و روی مهم‌ترین اقدام‌ها تمرکز داشته باشید.
                </p>
              </div>
              <div>
                <Button type="primary">شروع مدیریت</Button>
              </div>
            </div>
          </SwiperSlide>
        ))}
        <PaginationSwiper active={currentIndex} />
      </Swiper>
    </div>
  );
}
